import React from "react";
import { ArrowLeft, Plus } from "lucide-react";

interface AdminHeaderProps {
  onBack: () => void;
  onAddShop: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onBack, onAddShop }) => (
  <div className="flex flex-col gap-4 mb-6 md:mb-8">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          onClick={onBack}
          className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          title="Back to LoppeHub"
        >
          <ArrowLeft size={20} />
        </button>
        <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">Shop Administration</h1>
      </div>
    </div>
    <button
      onClick={onAddShop}
      className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors w-full sm:w-auto sm:self-start"
    >
      <Plus size={20} />
      Add Shop
    </button>
  </div>
);

export default AdminHeader;
